<section class="header-content">
  <ion-card class="content-editor__card">
    @if (contentData) {
    <ion-card-header class="content-editor__header">
      <ion-card-title class="content-editor__header--title">{{ contentData.title }}</ion-card-title>
      <ion-card-subtitle class="content-editor__header--subtitle">{{ contentData.description }}</ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <form [formGroup]="contentForm" (ngSubmit)="onSubmit()">
        <fieldset class="form-section">
          <ion-item lines="none">
            <ion-label class="form-section__title">Tipo de contenido</ion-label>
          </ion-item>
          <ion-radio-group formControlName="contentType">
            @for (item of contentTypeList; track $index) { @if (item.value ===
            type) {
            <ion-item lines="none">
              <ion-radio slot="start" [value]="item.value"></ion-radio>
              <ion-label class="form-section__option-label">{{ item.label }}</ion-label>
            </ion-item>
            }}
          </ion-radio-group>
        </fieldset>
        <fieldset class="form-section">
          <ion-item lines="none" class="section-separator">
            <ion-label class="form-section__title">Estado</ion-label>
          </ion-item>

          <ion-radio-group formControlName="state">
            @for (item of stateList; track $index) { @if (item.value !== 'Todos')
            {
              <div>
              <ion-item lines="none" class="item-auto-width">
                <ion-radio slot="start" [value]="item.value"></ion-radio>
                <ion-label class="form-section__option-label">{{ item.label }}</ion-label>
              </ion-item></div>
            }}
          </ion-radio-group>
        </fieldset>

        @if (type === 'privado') {
        <div>
          <app-content-managers (updateManagers)="getManagersList($event)" [contentForm]="contentForm " />
        </div>
        }

        <ion-item-divider></ion-item-divider>

        <div class="button-group">
          <ion-button fill="outline" (click)="handleRedirect(true)">Cancelar</ion-button>
          <ion-button spinnerClickButton="6000" fill="solid" size="small" type="submit"
            [disabled]="disabledSave || contentForm.invalid">Guardar</ion-button>
        </div>
      </form>
    </ion-card-content>}
  </ion-card>
</section>
